import { render } from "./DialogImportDependencies.vue?vue&type=template&id=1c063b05"
import script from "./DialogImportDependencies.vue?vue&type=script&lang=js"
export * from "./DialogImportDependencies.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__